export default "__VITE_ASSET__IKYBab7x__"